<template>
    <b-overlay :show="getting" rounded opacity="1">
        <div class="p-1">
            <div class="text-right" v-if="value.exitTaskId && locked && !value.InTheApprovalProcess">
                <button class="btn btn-primary btn-sm mb-1" v-on:click="locked = false">Düzenle</button>
                <v-executer :loading="cancelling" :action="cancel" class="btn-sm ml-1 mb-1" variant="danger">İptal Et</v-executer>
            </div>
            <div class="row">
                <!-- <div class="col-12 mb-1">
                    <b-form-checkbox v-model="value.SGK" disabled>SGK'ya Bildir</b-form-checkbox>
                </div> -->
                <div class="col-12 mb-1">
                    <ul class="list-group">
                        <li class="list-group-item p-75">
                            <label class="form-label text-secondary">Tebliğ Tarihi</label>
                            <v-date-picker v-model="value.NotifyDate" :disabled="locked" v-on:input="getTimes(true)" placeholder="Tebliğ Tarihi"></v-date-picker>
                        </li>
                        <li class="list-group-item p-75" v-if="value.NotifyDate">
                            <label class="form-label text-secondary">İhbar Öneli Kullanılacak Mı?</label>
                            <div>
                                <b-form-radio v-on:change="getTimes(true)" :disabled="locked" inline v-model="value.IhbarOneliKullanacak" :value="true">Evet</b-form-radio>
                                <b-form-radio v-on:change="getTimes(true,true)" :disabled="locked" inline v-model="value.IhbarOneliKullanacak" :value="false">Hayır</b-form-radio>
                            </div>
                        </li>
                        <li class="list-group-item p-75" v-if="(times||[]).length && value.NotifyDate && value.IhbarOneliKullanacak">
                            <label class="form-label text-secondary">İhbar Öneli Süresi</label>
                            <v-select-list :options="times" :loading="calculating" :disabled="calculating || locked" v-on:input="calculate" label="Text" v-model="selectedTime" placeholder="İhbar Öneli Süresi"></v-select-list>
                        </li>
                        <li class="list-group-item p-75" v-if="value.NotifyDate && value.IhbarOneliSuresi">
                            <label class="form-label text-secondary">İşten Çıkış Tarihi</label>
                            <v-date-picker v-model="value.istenCikisTarihi" :disabled="value.IhbarOneliKullanacak || locked" placeholder="İşten Çıkış Tarihi"></v-date-picker>
                        </li>
                        <li class="list-group-item p-75" v-if="value.NotifyDate && value.IhbarOneliKullanacak == false">
                            <label class="form-label text-secondary">İşten Çıkış Tarihi</label>
                            <v-date-picker v-model="value.istenCikisTarihi" :disabled="locked" placeholder="İşten Çıkış Tarihi"></v-date-picker>
                        </li>
                    </ul>
                </div>
                <div class="col-12 mb-1">
                    <label class="form-label text-secondary">Çıkış Sebebi Türü</label>
                    <v-select-list :options="causes" :disabled="locked" v-model="cause" v-on:input="getReasons()" placeholder="Çıkış Sebebi Türü" label="Name"></v-select-list>
                </div>
                <div class="col-12 mb-1" v-if="cause">
                    <ul class="list-group">
                        <li class="list-group-item p-75" >
                            <label class="form-label text-secondary">İhtar çekildi mi?</label>
                            <div>
                                <b-form-radio inline v-model="value.Ihtar" :disabled="locked" :value="true">Evet</b-form-radio>
                                <b-form-radio inline v-model="value.Ihtar" :disabled="locked" :value="false">Hayır</b-form-radio>
                            </div>
                        </li>
                        <li class="list-group-item p-75 d-flex align-items-center g-50" v-if="value.exitTaskIhtarFilePath && !value.exitTaskIhtarFileDeleted && value.IhtarFile == null">
                            {{ fileName }}
                            <button :disabled="locked" class="btn btn-sm btn-outline-primary ml-auto" v-on:click="download">İndir</button>
                            <button :disabled="locked" class="btn btn-sm btn-danger" v-on:click="value.exitTaskIhtarFileDeleted = true">Sil</button>
                        </li>
                        <li class="list-group-item p-75" v-if="value.Ihtar">
                            <label class="form-label">{{ $safe(cause,'Code') == 'istifa' ? 'İşçi Tarafından' : 'İşveren Tarafından' }}</label>
                            <v-file-uploader :disabled="locked" :accept="['xls','xlsx']" :value="value" value-parameter="IhtarFile"></v-file-uploader>
                        </li>
                    </ul>
                </div>
                <div class="col-12 mb-1">
                    <ul class="list-group">
                        <li class="list-group-item p-75" >
                            <label class="form-label text-secondary">Vukuat var mı?</label>
                            <div>
                                <b-form-radio inline v-model="value.Vukuat" :disabled="locked" :value="true">Evet</b-form-radio>
                                <b-form-radio inline v-model="value.Vukuat" :disabled="locked" :value="false">Hayır</b-form-radio>
                            </div>
                        </li>
                        <li class="list-group-item p-75" v-if="value.Vukuat">
                            <label class="form-label">Açıklama</label>
                            <textarea class="form-control resize-none" rows="3" :disabled="locked" v-model="value.VukuatAciklama"></textarea>
                        </li>
                    </ul>
                </div>
                <div class="col-12 mb-1">
                    <label class="form-label">SGK Şubesi</label>
                    <v-select-list :options="sgkBranches" label="Name" v-model="sgkBranch" placeholder="SGK Şube" disabled></v-select-list>
                </div>
                <div class="col-12 mb-1">
                    <b-form-checkbox v-model="value.BranchTransfer" disabled>Transfer</b-form-checkbox>
                </div>
                <div class="col-12 mb-1" v-if="value.BranchTransfer">
                    <label class="form-label">Transfer SGK Şubesi</label>
                    <v-select-list :options="transferableSgkBranches" label="Name" :disabled="locked" v-model="transferSgkBranch" placeholder="Transfer SGK Şube"></v-select-list>
                </div>
                <div class="col-lg-6 mb-1" v-if="value.SGK">
                    <label class="form-label" >Nakil Gideceği İşyeri Sicil</label>
                    <input type="text" class="form-control" v-model="value.nakilGidecegiIsyeriSicil" placeholder="Nakil Gideceği İşyeri Sicil"/>
                </div>
                <div class="col-lg-12 mb-1">
                    <label class="form-label">İşten Çıkış Ana Sebebi</label>
                    <v-select-list :options="reasons" v-model="reason" :disabled="locked" placeholder="İşten Çıkış Ana Sebebi" label="Value"></v-select-list>
                </div>
                <div class="col-lg-6 mb-1">
                    <label class="form-label">İşten Çıkış Özel Sebebi</label>
                    <v-select-list :options="parentJobExitSpecialCauses" :disabled="locked" v-model="parentSpecialCause" label="Name" v-on:input="getJobExitSpecialCauses(true)" placeholder="İşten Çıkış Özel Sebebi"></v-select-list>
                </div>
                <div class="col-lg-6 mb-1">
                    <label class="form-label">İşten Çıkış Özel Alt Sebebi</label>
                    <v-select-list :disabled="!parentSpecialCause || (jobExitSpecialCauses || []).length == 0 || locked" multiple label="Name" :options="jobExitSpecialCauses" v-model="specialCause" placeholder="İşten Çıkış Özel Alt Sebebi"></v-select-list>
                </div>
                <div class="col-lg-6 mb-1" v-if="value.SGK">
                    <label class="form-label">Meslek Kodu</label>
                    <v-select-list :options="jobCodes" v-model="jobCode" placeholder="Meslek Kodu" label="Name"></v-select-list>
                </div>
                <div class="col-lg-6 mb-1" v-if="value.SGK">
                    <label class="form-label">Çalışma ve Sosyal Güvenlik Bakanlığı İş Kolu</label>
                    <v-select-list :options="businessLines" v-model="businessLine" placeholder="Çalışma ve Sosyal Güvenlik Bakanlığı İş Kolu" label="Value"></v-select-list>
                </div>
                <div class="col-lg-6 mb-1 mb-lg-0" v-if="value.SGK">
                    <div class="alert alert-dark mb-0">
                        <div class="alert-body">
                            <h5>Bulunduğumuz Dönem</h5>
                            <hr class="mt-0"/>
                            <div class="row">
                                <div class="col-12 mb-50">
                                    <label class="from-label">Belge Türü</label>
                                    <v-select-list :options="docTypes" v-model="currentDocType" placeholder="Belge Türü" label="Value"></v-select-list>
                                </div>
                                <div class="col-12 mb-50">
                                    <label class="from-label">Hakedilen Tutar (TL)</label>
                                    <input type="number" class="form-control" placeholder="Hakedilen Tutar (TL)" v-model="value.bulundugumuzDonem.hakedilenucret">
                                </div>
                                <div class="col-12 mb-50">
                                    <label class="from-label">Prim İkramiye Tutarı (TL)</label>
                                    <input type="number" class="form-control" placeholder="Prim İkramiye Tutarı (TL)" v-model="value.bulundugumuzDonem.primikramiye">
                                </div>
                                <div class="col-12 mb-50">
                                    <label class="from-label">Eksik Gün Sayısı</label>
                                    <input type="number" class="form-control" placeholder="Eksik Gün Sayısı" v-model="value.bulundugumuzDonem.eksikgunsayisi">
                                </div>
                                <div class="col-12">
                                    <label class="from-label">Eksik Gün Nedeni</label>
                                    <v-select-list :options="missingDayReasons" v-model="currentMissingDayReason" placeholder="Eksik Gün Nedeni" label="Value"></v-select-list>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 mb-1" v-if="value.SGK">
                    <div class="alert alert-dark mb-0">
                        <div class="alert-body">
                            <h5>Önceki Dönem</h5>
                            <hr class="mt-0"/>
                            <div class="row">
                                <div class="col-12 mb-50">
                                    <label class="from-label">Belge Türü</label>
                                    <v-select-list :options="docTypes" v-model="prevDocType" placeholder="Belge Türü" label="Value"></v-select-list>
                                </div>
                                <div class="col-12 mb-50">
                                    <label class="from-label">Hakedilen Tutar (TL)</label>
                                    <input type="number" class="form-control" placeholder="Hakedilen Tutar (TL)" v-model="value.oncekiDonem.hakedilenucret">
                                </div>
                                <div class="col-12 mb-50">
                                    <label class="from-label">Prim İkramiye Tutarı (TL)</label>
                                    <input type="number" class="form-control" placeholder="Prim İkramiye Tutarı (TL)" v-model="value.oncekiDonem.primikramiye">
                                </div>
                                <div class="col-12 mb-50">
                                    <label class="from-label">Eksik Gün Sayısı</label>
                                    <input type="number" class="form-control" placeholder="Eksik Gün Sayısı" v-model="value.oncekiDonem.eksikgunsayisi">
                                </div>
                                <div class="col-12">
                                    <label class="from-label">Eksik Gün Nedeni</label>
                                    <v-select-list :options="missingDayReasons" v-model="prevMissingDayReason" placeholder="Eksik Gün Nedeni" label="Value"></v-select-list>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-auto col-12 mb-1">
                    <b-form-checkbox class="custom-control-danger text-danger" :disabled="locked" v-model="value.Harmful">Tekrar işe alımı sakıncalı</b-form-checkbox>
                </div>
                <div class="col-lg-auto col-12 mb-1">
                    <b-form-checkbox class="custom-control-info" :disabled="locked" v-model="value.EYT"><span class="text-info">EYT</span></b-form-checkbox>
                </div>
                <!-- Dummy (temsili) çıkış: işaretlenirse çıkış kaydı temsili sayılır ve
                     kıdem hesabında GÖZ ARDI edilir. Mevcut çıkış kayıtları için aynı
                     işaret SGK Hareketleri ekranından da verilebilir. -->
                <div class="col-lg-auto col-12 mb-1">
                    <b-form-checkbox class="custom-control-secondary" :disabled="locked" v-model="value.Dummy">
                        <span class="text-secondary">Dummy (Temsili) Çıkış</span>
                    </b-form-checkbox>
                </div>
                <!-- "Her şey dahil" 2. adıma (Hakediş Ön İnceleme) taşındı: Evet/Hayır seçimi zorunlu. -->
                <div class="col-12 mb-1" v-if="value.Harmful">
                    <label class="from-label">Sakınca Nedeni</label>
                    <textarea class="form-control" v-model="value.HarmfulReason" placeholder="Sakınca Nedeni"></textarea>
                </div>
                <div class="col-12 mb-1">
                    <label class="from-label">Şirkete Borcu</label>
                    <div class="d-flex align-items-center g-1">
                        <v-currency-input class="flex-grow-1" input-class="text-right" :disabled="locked" :value="value.SirketeBorcu" v-on:update-value="currencyAmount => value.SirketeBorcu = currencyAmount"></v-currency-input>
                        <div class="flex-shrink-0">
                            <b-form-radio inline :disabled="locked" v-model="value.SirketeBorcuBankaTipi" :value="1">Banka 1</b-form-radio>
                            <b-form-radio inline :disabled="locked" v-model="value.SirketeBorcuBankaTipi" :value="2">Banka 2</b-form-radio>
                        </div>
                    </div>
                </div>
                <div class="col-12 mb-1" v-if="value.exitTaskId">
                    <div class="alert alert-secondary mb-0">
                        <div class="alert-body d-flex align-items-center pr-75">
                            <b>{{ fullName }}</b>&nbsp;isimli personelin puantajını düzenleyebilirsiniz.
                            <button class="btn btn-secondary btn-sm ml-auto" v-on:click="goToScore">
                                Düzenle
                                <feather-icon icon="ExternalLinkIcon"></feather-icon>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="col-12 mb-1" v-if="value.hasLevy">
                    <div class="alert alert-secondary mb-0">
                        <div class="alert-body d-flex align-items-center pr-75">
                            <b>Personelin icrası var.</b>
                        </div>
                    </div>
                </div>
                <div class="col-12 mb-1" v-if="value.InTheApprovalProcess">
                    <div class="alert alert-info mb-0">
                        <div class="alert-body d-flex align-items-center pr-75">
                            Bu personelin çıkışı onay sürecindedir.
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="d-flex justify-content-end g-1">
                        <v-executer variant="secondary" :action="sendApprove" :loading="sendingApprove" v-if="value.exitTaskId && !value.InTheApprovalProcess">
                            Onaya Gönder
                        </v-executer>
                        <v-executer variant="danger" :action="save" :loading="exiting" :disabled="locked" v-if="!value.InTheApprovalProcess">
                            {{value.exitTaskId ? 'Bilgileri Güncelle' : 'Bilgileri Kaydet'}}
                        </v-executer>
                        <v-executer variant="primary" :action="check" :loading="checking" v-if="this.value.exitTaskId">
                            Devam Et
                        </v-executer>
                    </div>
                </div>
            </div>
        </div>
    </b-overlay>
</template>

<script>
import HumanResourcesParameterApi from '@/api/human-resources-parameters'
import EmployeeOperationsApi from '@/api/employee-operations'
import SystemDataApi from '@/api/system-data'
import CompanyApi from '@/api/company'
import { BFormRadio,BFormCheckbox, BSpinner, BOverlay } from 'bootstrap-vue'
import moment from 'moment'
import VFileUploader from '@/components/v-file-uploader/VFileUploader.vue'
import VCurrencyInput from '@/components/VCurrencyInput.vue'
import Additional from '@/utilities/additional'
import { AES } from 'crypto-js'
import SGKExitApi from '@/api/sgk-exit'

export default {
    components:{
        BFormRadio,
        BFormCheckbox,
        BSpinner,
        BOverlay,
        VFileUploader,
        VCurrencyInput
    },
    props:{
        id:[Number,String],
        value:Object,
        canExit:Boolean,
        sgkEntry:[Object,null],
        isDriver:Boolean,
        fullName:String
    },
    data(){
        return{
            causes:[],
            businessLines:[],
            jobCodes:[],
            reasons:[],
            docTypes:[],
            missingDayReasons:[],
            sgkBranches:[],
            gettingTimes:false,
            calculating:false,
            times:[],
            parentJobExitSpecialCauses:[],
            jobExitSpecialCauses:[],
            getting:false,
            exiting:false,
            checking:false,
            locked:false,
            cancelling:false,
            sendingApprove: false
        }
    },
    watch:{
        "value.BranchTransfer"(){
            this.value.TransferBranchId = null
        },
        "value.SGKParameterId"(){
            this.getParentJobExitSpecialCauses()
        }
    },
    created(){
        // Vue 2 reaktivite: value objesinde olmayabilecek yeni alanları reaktif olarak tanımla
        // (yeni çıkış kaydında getTask map bloğu çalışmaz; bu alanlar aksi halde reaktif olmaz ve kaydedilmez).
        // HerSeyDahil burada TANIMLANMAZ: 2. adımda seçilir. 1. adım bu alanı hiç göndermez,
        // böylece backend'de "seçilmedi" (null) durumu 2. adımdaki seçimi ezmez.
        if(this.value.SirketeBorcuBankaTipi === undefined) this.$set(this.value, 'SirketeBorcuBankaTipi', null)
    },
    mounted(){
        this.getTask().then(() => {
            this.getCauses()
            this.getCSGB()
            this.getJobCodes()
            this.getReasons()
            this.getDocTypes()
            this.getMissingDayReasons()
            this.getBranches()
            this.getParentJobExitSpecialCauses()
            this.getTimes(false)
            this.getJobExitSpecialCauses(false)
        })

    },
    methods:{
        goToScore(){
            let route =  this.$router.resolve({
                name: this.isDriver ? 'monthly-score' : 'not-driver-monthly-score',
                query: {q:encodeURI(AES.encrypt(JSON.stringify({
                    exit:true,
                    employeeId:this.id,
                    exitDate: this.value.istenCikisTarihi,
                    name:this.fullName,
                    notifyDate: this.value.NotifyDate
                }),'exit').toString())}
            })
            window.open(route.href, "_blank")
        },
        sendApprove(){
            this.sendingApprove = true
            SGKExitApi.TaskToApproval(this.value.exitTaskId).then(res => {
                if(res.data.Success){
                    this.getTask()
                }
                this.$result(res)
                this.sendingApprove = false
            }).catch(err => {
                this.$result(null,err)
                this.sendingApprove = false
            })
        },
        getTask(){
            return new Promise((resolve) => {
                this.getting = true
                EmployeeOperationsApi.exitTaskInfo(this.id).then(res =>{
                    this.getting = false
                    const data = res.data.Data
                    if(data && res.data.Success){
                        this.locked = true
                        this.value.exitTaskId = data.Id || null
                        this.value.hasLevy = data.HasLevy || false
                        this.value.JobExitCauseId = data.JobExitCauseId || null
                        this.value.IhbarOneliKullanacak = data.IhbarOneliKullanacak || false
                        this.value.IhbarOneliSuresi = data.IhbarOneliSuresi || null
                        this.value.IhbarOneliWorkDay = data.IhbarOneliWorkDay || false
                        this.value.NotifyDate = data.NotifyDate ? moment(data.NotifyDate).format('YYYY-MM-DD') : null
                        this.value.Harmful = data.Harmful || false
                        this.value.HarmfulReason = data.HarmfulReason || null
                        this.value.ParentJobExitSpecialCauseId = data.ParentJobExitSpecialCauseId || null
                        this.value.JobExitSpecialCauseIds = (data.JobExitSpecialCauses || []).map(x => x.Key)
                        this.value.istenCikisTarihi = data.istenCikisTarihi || null
                        this.value.istenCikisNedeni = data.istenCikisNedeni || null
                        this.value.SGKParameterId = data.SGKParameterId || null
                        this.value.meslekkodu = data.meslekkodu || null
                        this.value.csgbiskolu = data.csgbiskolu || null
                        this.value.SirketeBorcu = data.SirketeBorcu || null
                        this.value.SirketeBorcuBankaTipi = data.SirketeBorcuBankaTipi || null
                        this.value.EYT = data.EYT || false
                        this.value.Dummy = data.Dummy || false
                        this.value.TransferBranchId = data.TransferBranchId || null
                        this.value.Ihtar = data.Ihtar || false
                        this.value.Vukuat = data.Vukuat || false
                        this.value.VukuatAciklama = data.VukuatAciklama || null
                        this.value.exitTaskIhtarFilePath = data.IhtarFilePath
                        this.value.InTheApprovalProcess = data.InTheApprovalProcess
                        this.$emit('approve-statuses',data.ApprovalStatuses || [])
                        this.$nextTick(()=>{
                            resolve(true)
                        })
                    } else if(!res.data.Success){
                        if(data){
                            this.value.hasLevy = data.HasLevy || false
                        }
                        this.$result(res)
                        resolve()
                    }
                }).catch(err => {
                    this.getting = false
                    this.$result(null,err)
                    resolve(true)
                })
            })
        },
        getCauses(){
            HumanResourcesParameterApi.JobExitCause.List().then(res=>{
                this.causes = res.data.Data
            })
        },
        getCSGB(){
            EmployeeOperationsApi.Employee.SGK.Type("csgbiskolu").then(res=>{
                this.businessLines = res.data.Data
            })
        },
        getJobCodes(){
            SystemDataApi.OccupationTitle().then(res=>{
                this.jobCodes = res.data.Data
            })
        },
        getReasons(){
            if(this.value.JobExitCauseId){
                EmployeeOperationsApi.Employee.SGK.TypeWithJobExitCause("istenCikisNedeni",this.value.JobExitCauseId).then(res=>{
                    this.reasons = res.data.Data?.map(r=>({
                        ...r,
                        Value:[r.Code,r.Value].join(" - ")
                    })).sort((a,b) => Number(a.Code) - Number(b.Code))
                })
            }
        },
        getDocTypes(){
            EmployeeOperationsApi.Employee.SGK.Type("belgeturu").then(res=>{
                this.docTypes = res.data.Data
            })
        },
        getMissingDayReasons(){
            EmployeeOperationsApi.Employee.SGK.Type("eksikgunnedeni").then(res=>{
                this.missingDayReasons = res.data.Data
            })
        },
        getBranches(){
            CompanyApi.Branch.ListByCode("S").then(res=>{
                this.sgkBranches = res.data.Data
            })
        },
        getTimes(bool,bool2){
            if(bool2) {
                this.value.istenCikisTarihi = this.value.NotifyDate
                this.value.IhbarOneliSuresi = null
            }
            else{
                let jsd = this.sgkEntry.Date ? moment(this.sgkEntry.Date,'DD.MM.YYYY').format('YYYY-MM-DD') : null
                if(jsd){
                    this.gettingTimes = true
                    EmployeeOperationsApi.Employee.SGK.CalculateUseOfNotice(jsd,this.value.NotifyDate).then(res=>{
                        this.gettingTimes = false
                        if(res.data.Success){
                            if(bool){
                                this.value.IhbarOneliSuresi = null
                                this.value.istenCikisTarihi = null
                            }
                            this.times = res.data.Data?.map(i=>{
                                return {
                                    ...i,
                                    Text:`${i.Value} ${i.WorkDay ? 'İş Günü' : 'Hafta'}`
                                }
                            })
                        }else this.$result(res)
                    }).catch(err=>{
                        this.gettingTimes = false
                        this.$result(null,err)
                    })
                }
            }
        },
        calculate(){
            this.calculating = true
            EmployeeOperationsApi.Employee.SGK.CalculateUseOfNoticeJobExitDate(this.selectedTime,this.value.NotifyDate).then(res=>{
                this.calculating = false
                if(res.data.Success){
                    this.value.istenCikisTarihi = res.data.Data
                }else this.$result(res)
            }).catch(err=>{
                this.calculating = false
                this.$result(null,err)
            })
        },
        getParentJobExitSpecialCauses(){
            if(this.value.SGKParameterId){
                HumanResourcesParameterApi.JobExitSpecialCause.ParentListWithSGKParameterId(this.value.SGKParameterId).then(res=>{
                    this.parentJobExitSpecialCauses = res.data.Data
                })
            }
        },
        getJobExitSpecialCauses(bool = false){
            if(this.value.ParentJobExitSpecialCauseId){
                HumanResourcesParameterApi.JobExitSpecialCause.ListGetById(this.value.ParentJobExitSpecialCauseId).then(res=>{
                    if(bool == true) {
                        this.value.JobExitSpecialCauseIds = []
                    }
                    this.jobExitSpecialCauses = []
                    this.jobExitSpecialCauses = res.data.Data
                })
            }
        },
        download(){
            if(this.value.exitTaskIhtarFilePath){
                Additional.DownloadTab(this.value.exitTaskIhtarFilePath)
            }
        },
        save(){
            this.exiting = true
            const formData = new FormData()
            if(this.value.branchId != null) formData.append('BranchId',this.value.branchId)
            if(this.id != null) formData.append('EmployeeId',this.id)
            if(this.value.JobExitCauseId != null) formData.append('JobExitCauseId',this.value.JobExitCauseId)
            if(this.value.IhbarOneliKullanacak != null) formData.append('IhbarOneliKullanacak',this.value.IhbarOneliKullanacak)
            if(this.value.IhbarOneliSuresi != null) formData.append('IhbarOneliSuresi',this.value.IhbarOneliSuresi)
            if(this.value.IhbarOneliWorkDay != null) formData.append('IhbarOneliWorkDay',this.value.IhbarOneliWorkDay)
            if(this.value.NotifyDate != null) formData.append('NotifyDate',this.value.NotifyDate)
            if(this.value.Harmful != null) formData.append('Harmful',this.value.Harmful)
            if(this.value.HarmfulReason != null) formData.append('HarmfulReason',this.value.HarmfulReason)
            // HerSeyDahil GÖNDERİLMEZ (2. adımın alanı); gönderilirse oradaki seçim ezilir.
            if (Array.isArray(this.value.JobExitSpecialCauseIds)) {
                this.value.JobExitSpecialCauseIds.forEach(id => {
                    formData.append('JobExitSpecialCauseIds', id)
                })
            }
            if(this.value.ParentJobExitSpecialCauseId != null) formData.append('ParentJobExitSpecialCauseId',this.value.ParentJobExitSpecialCauseId)
            if(this.sgkEntry?.Id != null) formData.append('SGKEntryId',this.sgkEntry?.Id)
            if(this.value.istenCikisTarihi != null) formData.append('istenCikisTarihi',this.value.istenCikisTarihi)
            if(this.value.istenCikisNedeni!= null) formData.append('istenCikisNedeni',this.value.istenCikisNedeni)
            if(this.value.meslekkodu != null) formData.append('meslekkodu',this.value.meslekkodu)
            if(this.value.csgbiskolu != null) formData.append('csgbiskolu',this.value.csgbiskolu)
            if(this.value.SirketeBorcu != null) formData.append('SirketeBorcu',this.value.SirketeBorcu)
            if(this.value.SirketeBorcuBankaTipi != null) formData.append('SirketeBorcuBankaTipi',this.value.SirketeBorcuBankaTipi)
            if(this.value.Driver != null) formData.append('Driver',this.isDriver)
            if(this.value.EYT != null) formData.append('EYT',this.value.EYT)
            if(this.value.Dummy != null) formData.append('Dummy',this.value.Dummy)
            if(this.value.TransferBranchId != null) formData.append('TransferBranchId',this.value.TransferBranchId)
            if(this.value.Ihtar != null) formData.append('Ihtar',this.value.Ihtar)
            if(this.value.IhtarFile != null) formData.append('IhtarFile',this.value.IhtarFile)
            if(this.value.Vukuat != null) formData.append('Vukuat',this.value.Vukuat)
            if(this.value.VukuatAciklama != null) formData.append('VukuatAciklama',this.value.VukuatAciklama)
            if(this.value.exitTaskIhtarFileDeleted) formData.append('IhtarFileDeleted',this.value.exitTaskIhtarFileDeleted)
            if(this.value.exitTaskId) formData.append('Id',this.value.exitTaskId)
            if(this.value.SGKParameterId) formData.append('SGKParameterId',this.value.SGKParameterId)
            //IhtarFileDeleted == true && File => new File
            //IhtarFileDeleted == true && File == null => remove File
            //IhtarFileDeleted == false && File => new File
            //IhtarFileDeleted == false && File == null => nothing
            EmployeeOperationsApi.jobExitTask(formData).then(res => {
                this.$result(res)
                this.exiting = false
                if(res.data.Success){
                    this.getTask()
                }
            }).catch(err => {
                this.$result(null,err)
                this.exiting = false
            })
        },
        check(){
            this.checking = true
            EmployeeOperationsApi.exitTaskCheckScore(this.value.exitTaskId).then(res => {
                this.$result(res)
                this.checking = false
                if(res.data.Success){
                    this.$emit('next-step')
                }
            }).catch(err => {
                this.$result(null,err)
                this.checking = false
            })
        },
        cancel(){
            this.cancelling=true
            EmployeeOperationsApi.jobExitTaskAbort(this.value.exitTaskId).then(res => {
                if(res.data.Success){
                    this.getTask()
                    this.value.exitTaskId = null
                }
                this.cancelling = false
                this.$result(res)
            }).catch(err => {
                this.cancelling = false
                this.$result(null,err)
            })
        }
    },
    computed:{
        cause:{
            get:function(){
                return this.causes.find(c=>c.Id == this.value.JobExitCauseId)
            },
            set:function(value){
                this.value.JobExitCauseId = value?.Id || null
                this.value.JobExitCauseCode = value?.Code || null
            }
        },
        parentSpecialCause:{
            get:function(){
                return this.parentJobExitSpecialCauses.find(c=>c.Id == this.value.ParentJobExitSpecialCauseId)
            },
            set:function(value){
                this.value.ParentJobExitSpecialCauseId = value?.Id || null
            }
        },
        specialCause:{
            get:function(){
                return this.jobExitSpecialCauses.filter(c=>(this.value.JobExitSpecialCauseIds || []).includes(c.Id))
            },
            set:function(value){
                this.value.JobExitSpecialCauseIds = value?.map(s => s.Id) || []
            }
        },
        transferableSgkBranches(){
            return this.sgkBranches.filter(b=>b.Id != this.value.branchId)
        },
        businessLine:{
            get:function(){
                return this.businessLines.find(i=>i.Code==this.value.csgbiskolu)
            },
            set:function(value){
                this.value.csgbiskolu = value?.Code || null
            }
        },
        jobCode:{
            get:function(){
                return this.jobCodes.find(i=>i.SGKOccupationCode==this.value.meslekkodu)
            },
            set:function(value){
                this.value.meslekkodu = value?.SGKOccupationCode || null
            }
        },
        reason:{
            get:function(){
                return this.reasons.find(i=>i.Code==this.value.istenCikisNedeni)
            },
            set:function(value){
                this.value.istenCikisNedeni = value?.Code || null
                this.value.SGKParameterId = value?.ParameterId || null
            }
        },
        currentDocType:{
            get:function(){
                return this.docTypes.find(i=>i.Code==this.value.bulundugumuzDonem.belgeturu)
            },
            set:function(value){
                this.value.bulundugumuzDonem.belgeturu = value?.Code || null
            }
        },
        prevDocType:{
            get:function(){
                return this.docTypes.find(i=>i.Code==this.value.oncekiDonem.belgeturu)
            },
            set:function(value){
                this.value.oncekiDonem.belgeturu = value?.Code || null
            }
        },
        currentMissingDayReason:{
            get:function(){
                return this.missingDayReasons.find(i=>i.Code==this.value.bulundugumuzDonem.eksikgunnedeni)
            },
            set:function(value){
                this.value.bulundugumuzDonem.eksikgunnedeni = value?.Code || null
            }
        },
        prevMissingDayReason:{
            get:function(){
                return this.missingDayReasons.find(i=>i.Code==this.value.oncekiDonem.eksikgunnedeni)
            },
            set:function(value){
                this.value.oncekiDonem.eksikgunnedeni = value?.Code || null
            }
        },
        sgkBranch:{
            get:function(){
                return this.sgkBranches.find(b=>b.Id==this.value.branchId)
            },
            set:function(value){
                this.value.branchId = value?.Id || null
            }
        },
        transferSgkBranch:{
            get:function(){
                return this.sgkBranches.find(b=>b.Id==this.value.TransferBranchId)
            },
            set:function(value){
                this.value.TransferBranchId = value?.Id || null
            }
        },
        selectedTime:{
            get:function(){
                return this.times.find(b=> b.Value == this.value.IhbarOneliSuresi && b.WorkDay == this.value.IhbarOneliWorkDay)
            },
            set:function(value){
                this.value.IhbarOneliSuresi = value?.Value || null
                this.value.IhbarOneliWorkDay = value?.WorkDay != null ? value.WorkDay : null
            }
        },
        fileName(){
            if(this.value.exitTaskIhtarFilePath){
                const splited = this.value.exitTaskIhtarFilePath.split('/')
                const name = splited[splited.length - 1]?.split('_')
                return name[name.length - 1]
            }else return null
        }
    }
}
</script>